module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAwAAAAOCAYAAAAbvf3sAAAAp0lEQVQokY2ROwrCQBRFT0Z7EawUrKxSKYmFgrgNcWnZSDaQ1kKwSJtebOy9Fs7IQ8xkDrxq7mHeB0mY2kuqJd191ZJ2NmPDW/VT/hPaiND+CnkkHMgl4fhQMMwG+ArjBGFkhUOCcATIJE2Ah5H7eAFTB5wSwqGbM5KahA0FGgfMgVvCD1dgkUla+xm6AWEJzOylq0grVciF/ZfACniajYRB8W8FcHkDcywVJbJIFMgAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/images/home/1-47.png
// module id = aS0Y
// module chunks = 15